module.exports = __webpack_public_path__ + "static/media/em-01.eda2879d.png";